import { ApeironBlueButton } from '@apeiron/temp'
import IconTick from '@mui/icons-material/CheckCircle'
import { Box, styled, Typography } from '@mui/material'
import { FC, useCallback } from 'react'
import { Trans, useTranslation } from 'react-i18next'

const Container = styled(Box)`
  background-color: #353738;
  border-radius: 4px;
  overflow: hidden;
`

const Title = styled(Typography)`
  background-color: #454748;
  font-size: 16px;
  padding: 4px 10px;
`

const DescriptionContainer = styled(Box)`
  align-items: center;
  display: flex;
  gap: 12px;
  padding: 8px 10px;
  ${props => props.theme.breakpoints.down('res1024')} {
    flex-direction: column;
  }
`

const RightContainer = styled(Box)`
  height: 100%;
  width: 134px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const Description = styled(Typography)`
  color: #c4c4c4;
  font-family: 300;
  font-size: 12px;
  line-height: 22px;
  white-space: break-spaces;
`

const GoButton = styled(ApeironBlueButton)`
  height: unset;
  padding: 8px 60px;
  width: 100%;
  min-width: 100%;
`

const OrangeText = styled(Typography)`
  color: #ffbf36;
  font-size: 12px;
  display: inline;
  font-weight: 300;
  padding: 0px 4px;
  background-color: #ffffff11;
`

const TickIcon = styled(IconTick)`
  font-size: 50px;
  color: #53a513;
  background-color: white;
  clip-path: circle(40%);
`

const CheckInMakeupStep: FC<Props> = (props: Props) => {
  const { description, title, url, madeUp } = props

  const { t } = useTranslation()

  const handleOnClick = useCallback(() => {
    window.open(url, '_blank')
  }, [url])

  return (
    <Container>
      <Title>{title}</Title>
      <DescriptionContainer>
        <Description>
          <Trans
            components={{
              orange: <OrangeText />
            }}
          >
            {description}
          </Trans>
        </Description>
        <RightContainer>
          {!madeUp && (
            <GoButton onClick={handleOnClick}>{t('common.go')}</GoButton>
          )}
          {madeUp && <TickIcon />}
        </RightContainer>
      </DescriptionContainer>
    </Container>
  )
}

type Props = {
  description: string
  title: string
  url: string
  madeUp: boolean
}

export default CheckInMakeupStep
